export default "__VITE_ASSET__BTiY_1g6__"